import React from 'react'
import styles from '../styles.module.css'
import SpecsCollapsible from '../SpecsCollapsible'

function BundleSpecifications({ items, theme }) {
  const allItemSpecsByCategory = {}
  const specItems = items.filter(i => !!i.specs)
  const allCategories = new Set(
    specItems.flatMap(i => Object.keys(i.specs.specsByCategory))
  )

  specItems.forEach(i => {
    allCategories.forEach(category => {
        let currSpecsForCat = allItemSpecsByCategory[category] ? allItemSpecsByCategory[category] : []
        const specsForItem = i.specs.specsByCategory[category]
        if (specsForItem && specsForItem.length > 0) {
          currSpecsForCat.push({ name: i.name, value: null, isItemName: true })
          currSpecsForCat = currSpecsForCat.concat(i.specs.specsByCategory[category])
          allItemSpecsByCategory[category] = currSpecsForCat
        }
      })
  })

  if (Object.keys(allItemSpecsByCategory).length === 0) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      { [...allCategories].map(category =>
        <SpecsCollapsible
          key={category}
          category={category}
          specs={allItemSpecsByCategory[category]}
          theme={theme}
        />
      )}
    </div>
  )
}

export default BundleSpecifications
